<script lang="ts" setup>
defineProps({
  checked: {
    type: Boolean,
    default: false
  }
});

const emits = defineEmits(["click"]);

const onClick = () => {
  emits("click");
};

// トグルボタンの円のスタイル
const circle = {
  color: "#FFFFFF",
  diameter: "20px",
  borderRadius: "100%",
  distance: "15px" // トグルボタンON/OFF時の円の中心移動距離
};

// トグルボタン外周の楕円形部分のスタイル
const track = {
  color: "#D9D9D9",
  activeColor: "#3F88AE",
  width: "40px",
  height: "24px",
  borderWidth: "0px",
  borderRadius: "70px"
};

const toggleStyle = {
  "--circle-color": circle.color,
  "--circle-diameter": circle.diameter,
  "--circle-border-radius": circle.borderRadius,
  "--circle-distance": circle.distance,
  "--track-color": track.color,
  "--track-active-color": track.activeColor,
  "--track-width": track.width,
  "--track-height": track.height,
  "--track-border-width": track.borderWidth,
  "--track-border-radius": track.borderRadius
};
</script>

<template>
  <div class="toggle-wrapper" :style="toggleStyle">
    <label class="toggle-button" data-testid="toggle-button">
      <!-- 上位の要素をクリックしたときにinputのクリックイベントと重複しないよう、input内に@clickを設定 -->
      <input :checked="checked" type="checkbox" @click="onClick" />
      <span class="toggle-track">
        <span class="toggle-circle"></span>
      </span>
    </label>
  </div>
</template>

<style lang="scss" scoped>
.toggle-wrapper {
  height: var(--track-height);
}

.toggle-button {
  position: relative;
  display: inline-block;
  width: var(--track-width);
  height: var(--track-height);
  margin: 0;

  input {
    display: none;
  }

  .toggle-track {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    cursor: pointer;
    background-color: var(--track-color);
    border: var(--track-border-width) solid var(--track-color);
    border-radius: var(--track-border-radius);
    transition: 0.4s;

    .toggle-circle {
      position: absolute;
      left: 2px;
      display: flex;
      width: var(--circle-diameter);
      height: var(--circle-diameter);
      margin: auto 0;
      background-color: var(--circle-color);
      border-radius: var(--circle-border-radius);
      transition: 0.4s;
    }
  }

  input:checked + .toggle-track {
    background-color: var(--track-active-color);
    border: var(--track-border-width) solid var(--track-active-color);
  }

  input:checked + .toggle-track > .toggle-circle {
    // トグルボタンON時の円の中心移動
    transform: translateX(var(--circle-distance));
  }
}
</style>
